import { withProps } from 'recompose';

export default withProps(() => ({ noAutofill: true }));



// WEBPACK FOOTER //
// ./src/app/hoc/WithNoAutofill.js